// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__302-z","selected":"Chip_selected__3X5R3"};